// libs
import { styled } from '@nykaa/ui-components';

// constants
import { BREAKPOINTS } from 'shared/styles/base';

export const Container = styled.div`
  width: 100%;

  display: inline-block;
  vertical-align: top;

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    padding-left: ${({ theme }) => theme.spacing.spacing120};
    margin-left: ${({ theme }) => theme.spacing.spacing100};
  }

  padding-bottom: ${({ theme }) => theme.spacing.spacing80};

  .underline-btn {
    background: none;
    border: 0;
    text-align: left;
    padding: 0;
    margin: 0;
    text-decoration: underline;
    cursor: pointer;
    >div  {
      text-decoration: underline;
    }
  }
`;

export const Info = styled.div`
  :not(:last-child) {
    margin-bottom: ${({ theme }) => theme.spacing.spacing80};

    @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
      margin-bottom: ${({ theme }) => theme.spacing.spacing100};
    }
  }
`;

export const InfoTitle = styled.div`
  text-transform: capitalize;
  color: ${({ theme }) => theme.colors.textSecondary};
  ${({ theme }) => theme.typography.bodySmall}

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme }) => theme.typography.bodyMedium};
    color: ${({ theme }) => theme.colors.textSecondary};
`;

export const InfoContent = styled.div`
  ${({ theme }) => theme.typography.bodyMedium};
  color: ${({ theme }) => theme.colors.textPrimary};
  word-break: break-word;

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme }) => theme.typography.bodyLarge};
  }
`;
